import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../common_widgets/toast/notify";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_NOTIFY_POPUP,
} from "../mdae-common-reducer";
import {
  getTaskItem,
  isMaintenanceTask,
  openUserTaskInEditMode,
} from "../user-task-list/add-user-task";
import { SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW, TOGGLE_ADD_USER_TASK_POPUP } from "../user-task-list/reducers/user-task-list-reducer";
import { QUICK_COMPLETE_USER_TASK } from "../user-task-list/services/quick-complete-user-task";
import { convertDate } from "../../utils/dateUtils";
import { actions, callOperation } from "async-ops";
import {
  dateDifferenceInDays,
  GetDueDateContainerClass,
  getMyTaskDashboardWidgetIdList,
  MyTaskTimePeriodEnum,
} from "./component";
import { GET_MY_TASK_LIST } from "./services/get-my-task-list";
import {
  SET_CARD_TASK_DATA,
  SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
  TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
} from "./reducers/user-task-card-view-reducer";
import { NOTIFY_POPUP_TYPES } from "../common_widgets/notify-popup";
export interface ITaskCard {
  levelName: string;
  attachedLevel: string;
  auditId?: number;
  refTaskName?: string;
  dueDate: Date;
  completionDate?: Date;
  status: string;
  requiredForAuditCompletionInd: boolean;
  attachedDocumentCount?: number;
  refTaskDescription?: string;
  taskCategoryName?: string;
  taskCategoryTypeDisplayName?: string;
  drawerConfig: any;
  completedBy?: string;
  lastUpdatedNotesName?: string;
  auditorNotes?: string;
  managerNotes?: string;
  schedulingNotes?: string;
  myTaskRequestObject?: any;
  isFromMyTaskDashboardWidget?: any;
  isGroupByApplied?: boolean;
  groupByPropertyName?: string;
  myTaskGroupByAuditName?: string;
  myTaskDrawerId: string;
  refreshListHandler?: any;
  auditTitle?: string;
  assignedToUserId?: any;
  statusId?:string;
  externalNotes?:string;
  isExternalUser:boolean;
}

export const GetFormatedDueDate = function(dueDate) {
  dueDate = new Date(dueDate);
  return (
    dueDate.toLocaleString("default", { month: "short" }) +
    " " +
    dueDate.getDate()
  );
};
export const completeUserTask = (
  currentRowData,
  initialCardTaskData,
  dispatch,
  isExternalUser,
  isFromMyTaskDashboardWidget,
  refreshListHandler,
  myTaskRequestObject,
  isCancelUpdatedTask
) => {
  dispatch({ type: SHOW_LOADER });  
  const task = {
    completionDate: isCancelUpdatedTask ? null : new Date(),
    userTaskId: currentRowData.userTaskId,
    refTaskId: currentRowData.refTaskId,
    attachedLevelId: currentRowData.attachedLevelId,
    attachedLevel: currentRowData.attachedLevel,
    auditId: currentRowData.auditId,
    assignedToUserId: isCancelUpdatedTask
      ? initialCardTaskData?.assignedToUserId
      : currentRowData.assignedToUserId,
    isSavedFromExternalUser: isExternalUser ? true : false,
    refTaskName: currentRowData.refTaskName,
    statusId: isCancelUpdatedTask ? initialCardTaskData?.statusId : 0,
    notificationId: initialCardTaskData?.notificationId ? initialCardTaskData?.notificationId : currentRowData.notificationId,
    newUserTasksCreatedIds: initialCardTaskData?.newUserTasksCreatedIds,
    isCancelUpdatedTask: isCancelUpdatedTask,
  };
  callOperation(QUICK_COMPLETE_USER_TASK, task).then(function(response) {
    dispatch({ type: HIDE_LOADER });
    if (response.isUpdated) {
      const myTaskDashboardWidgetIdList = getMyTaskDashboardWidgetIdList();
      if (
        myTaskDashboardWidgetIdList &&
        myTaskDashboardWidgetIdList.length &&
        isFromMyTaskDashboardWidget
      ) {
        myTaskDashboardWidgetIdList.forEach((element) => {
          dispatch({
            type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
            data: {
              isRefreshMyTaskWidget: true,
              myTaskWidgetId: element,
            },
          });
        });
      }
      if (typeof refreshListHandler === "function") {
        refreshListHandler();
      } else {
        if (isExternalUser) {
          myTaskRequestObject.isForActiveTasksTab = true;
        }
        dispatch(
          actions.asyncOperationStart(GET_MY_TASK_LIST, myTaskRequestObject)
        );
      }
      if (!isExternalUser) {
        mdaeNotify({
          message: currentRowData.refTaskName + " - task updated successfully.",
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
      } else {
        if (!(isCancelUpdatedTask) )
          dispatch({
            type: TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
            data: {
              isCompleteTaskToastVisibleForCardView: true,
            },
          });
      }
    }

    let assignedToExternalUser = [];
    let newTaskCreated = [];

      
    if (response.newUserTasks && response.newUserTasks.length > 0) {
        for (var item of response.newUserTasks) {
            if (item.userTaskId) {
                response.newUserTasksCreated.push(item);
            }
        }
    }

    if (isExternalUser && response.newUserTasksCreated?.length > 0) {
      assignedToExternalUser = response.newUserTasksCreated.filter(
        (x) => x.assignedToUserId == currentRowData.assignedToUserId
      );
      newTaskCreated = assignedToExternalUser;
    } else {
      newTaskCreated = response.newUserTasksCreated;
    }
    if (newTaskCreated && newTaskCreated.length > 0) {
      var displayMessage = "";
      var arrayOfTaskItem = [];
      for (var item of response.newUserTasksCreated) {
        displayMessage =
          " " +
          item.refTaskName +
          ", " +
          "Assigned To: " +
          item.assignedToUserName +
          ", Due " +
          new Date(item.dueDate)?.toLocaleDateString();
        arrayOfTaskItem.push(displayMessage);
      }
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          visible: true,
          contentHtml: () => {
            return (
              <div>
                <div style={{ display: "block" }}>
                  New task(s) were created as a result of updating this task and
                  have been configured based on the process template.{" "}
                </div>
                <div>
                  <ul>{getTaskItem(arrayOfTaskItem)}</ul>
                </div>
              </div>
            );
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.ALERT,
          closeButtonText: "OK",
          width: 470,
          height: "auto",
        },
      });
    }
    dispatch({
      type: SET_CARD_TASK_DATA,
      data: {
        initialCardTaskData: {
          ...initialCardTaskData,
          notificationId: response.notificationId,
          newUserTasksCreatedIds: response.newUserTasksCreated?.map(
            (x) => x.userTaskId
          ),
        },
      },
    });
  });
};
const TaskCard: React.FC<ITaskCard> = (props) => {
  const currentUserId: any = useSelector(
    (state) => state["userTaskListReducer"].currentUserId,
    isEqual
  );
  let statusText;
  if (props.drawerConfig.drawerType === MyTaskTimePeriodEnum.Completed) {
    var days = dateDifferenceInDays(
      new Date(convertDate(new Date(props.dueDate))),
      new Date(convertDate(new Date(props.completionDate)))
    );
    statusText = days;
    var daysstr = Math.abs(days) == 1 || Math.abs(days) == 0 ? "day" : "days";

    if (days <= 0) {
      statusText = "Completed " + Math.abs(days) + " " + daysstr + " early";
    } else {
      statusText = "Completed " + Math.abs(days) + " " + daysstr + " late";
    }
  } else {
    statusText = props.status;
  }
  const dispatch = useDispatch();

  const isDocumentManagementEnabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentManagementEnabled,
    isEqual
  );
  const isCompleteTaskToastVisibleForCardView = useSelector(
    (state: any) => state["myTaskReducer"].isCompleteTaskToastVisibleForCardView,
    isEqual
  );
  const attachLevelEnums = useSelector(
    (state: any) => state["userTaskListReducer"].attachLevelEnums,
    isEqual
  );

  const toggleUserTaskPopup = (dispatch,isVisible, title, mode) => {
    dispatch({
      type: TOGGLE_ADD_USER_TASK_POPUP,
      data: {
        userTaskPopupMode: mode,
        userTaskPopupTitle: title,
        isAddUserTaskPopupVisible: isVisible,
      },
    });
  };
  let userTaskDescription = props.refTaskDescription;
  if (props.lastUpdatedNotesName) {
    switch (props.lastUpdatedNotesName.toLowerCase()) {
      case "auditornotes":
        if (props.auditorNotes) userTaskDescription = props.auditorNotes;
        else if (props.managerNotes) userTaskDescription = props.managerNotes;
        else if (props.schedulingNotes)
          userTaskDescription = props.schedulingNotes;
        break;
      case "managernotes":
        if (props.managerNotes) userTaskDescription = props.managerNotes;
        else if (props.auditorNotes) userTaskDescription = props.auditorNotes;
        else if (props.schedulingNotes)
          userTaskDescription = props.schedulingNotes;
        break;
      case "schedulingnotes":
        if (props.schedulingNotes) userTaskDescription = props.schedulingNotes;
        else if (props.auditorNotes) userTaskDescription = props.auditorNotes;
        else if (props.managerNotes) userTaskDescription = props.managerNotes;
        break;
    }
  }
  let cardTitle = props.levelName;
  if (props.attachedLevel?.toUpperCase() === "EA") {
    cardTitle = props.auditTitle;
  }
  if (
    props.isGroupByApplied &&
    props.attachedLevel?.toUpperCase() === "AE" &&
    props.groupByPropertyName &&
    props.groupByPropertyName.toLowerCase() === "mytaskgroupbyorgentityname"
  ) {
    cardTitle = props.myTaskGroupByAuditName;
  }

  const onUserTaskEditClick = (selectedRowData, userTaskSelectedIndex) => {
    openUserTaskInEditMode(
      selectedRowData,
      toggleUserTaskPopup,
      userTaskSelectedIndex,
      dispatch,
      false,
      true
    );
  };
  return (
    <div className={"user-task-card-container"}>
      <div
        className={
          "user-task-card-title dx-card " +
          props.attachedLevel.toLowerCase() +
          "-level-user-task-card-title"
        }
        style={{cursor: props.isExternalUser ? 'default': 'pointer'}}
        title={cardTitle}
        onClick={(e) => {
          if (!props.isExternalUser && props.auditId) {
            if (
              props.attachedLevel.toLowerCase() === "ea" ||
              props.attachedLevel.toLowerCase() === "eac"
            ) {
              window.open(
                "/externalaudit/audit/?auditId=" + props.auditId,
                "_blank"
              );
            } else {
              window.open("/audit/index/?auditId=" + props.auditId, "_blank");
            }
          }

          e.stopPropagation();
          return false;
        }}
      >
        {cardTitle}
      </div>
      <div
        onClick={() => {
          onUserTaskEditClick(props, 0);
        }}
        className={
          "user-task-card dx-theme-text-color dx-theme-background-color"
        }
      >
        <div className={"user-task-title-container"}>
          <div className={"user-task-card-name-container"}>
            <div className={"user-task-card-name"} title={props.refTaskName}>
              {props.refTaskName}
            </div>
            <div className={"user-task-card-status"} title={statusText}>
              {statusText}
            </div>
          </div>
          <div className={"user-task-card-icons-container"}>
            <div className={"user-task-card-due-date-section-container"}>
              <div
                className={GetDueDateContainerClass(
                  props.dueDate,
                  props.completedBy
                )}
              >
                <div
                  className={"fa fa-clock-o user-task-card-due-date-clock-icon"}
                ></div>
                <div
                  className={"user-task-card-due-date-text"}
                  title={GetFormatedDueDate(props.dueDate)}
                >
                  {GetFormatedDueDate(props.dueDate)}
                </div>
              </div>
            </div>

            <div className={"user-task-card-attachment-section-container"}>
              {isDocumentManagementEnabled &&
              props.attachedDocumentCount > 0 ? (
                <div
                  className={"user-task-card-attachment-icon-section-container"}
                  onClick={(e) => {
                    onUserTaskEditClick(props, 1);
                    e.stopPropagation();
                    return false;
                  }}
                >
                  <div
                    className={
                      "fas fa-paperclip user-task-card-attachment-paper-clip-icon"
                    }
                  ></div>
                  <div
                    className={
                      "user-task-card-attachment-count-section-container"
                    }
                  >
                    <div
                      className={
                        "user-task-card-attachment-count-sub-section-container"
                      }
                    >
                      <i
                        className={
                          "fa fa-circle user-task-card-attachment-count-circle-icon"
                        }
                      ></i>
                      <span
                        className={"user-task-card-attachment-count-text"}
                        style={{
                          left: props.attachedDocumentCount > 9 ? "2px" : "3px",
                        }}
                      >
                        {props.attachedDocumentCount}
                      </span>
                    </div>
                  </div>
                </div>
              ) : isDocumentManagementEnabled ? (
                <div
                  className={
                    "user-task-attachment-card-upload-icon-section-container"
                  }
                  onClick={(e) => {
                    if (isCompleteTaskToastVisibleForCardView) {
                      dispatch({
                        type: TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
                        data: {
                          isCompleteTaskToastVisibleForCardView: false,
                        },
                      });
                    }
                    onUserTaskEditClick(props, 1);
                    e.stopPropagation();
                    return false;
                  }}
                >
                  <div className={"dx-icon upload-icon"}></div>
                </div>
              ) : null}
              {(currentUserId === props.assignedToUserId ||
                props.drawerConfig.drawerType ===
                  MyTaskTimePeriodEnum.Completed) && (
                <div
                  onClick={(e) => {
                    if (
                      props.drawerConfig.drawerType !==
                      MyTaskTimePeriodEnum.Completed
                    ) {
                      if (isCompleteTaskToastVisibleForCardView) {
                        dispatch({
                          type: TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
                          data: {
                            isCompleteTaskToastVisibleForCardView: false,
                          },
                        });
                      }
                      var initialCardTaskData = {
                        statusId: props.statusId,
                        assignedToUserId: props.assignedToUserId,
                        externalNotes: props.externalNotes,
                        notificationId: 0,
                      };
                      dispatch({
                        type: SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW,
                        data: {
                          isOpenedFromCardView: true,
                          isMaintenanceLevelTask: isMaintenanceTask(
                            props,
                            attachLevelEnums
                          ),
                        },
                      });
                      completeUserTask(
                        props,
                        initialCardTaskData,
                        dispatch,
                        props.isExternalUser,
                        props.isFromMyTaskDashboardWidget,
                        props.refreshListHandler,
                        props.myTaskRequestObject,
                        false
                      );                  
                      dispatch({
                        type: SET_CARD_TASK_DATA,
                        data: {
                          currentCardTaskData: props,
                          initialCardTaskData: initialCardTaskData,
                        },
                      });
                      e.stopPropagation();
                      return false;
                    }
                  }}
                  className={
                    props.drawerConfig.drawerType ===
                    MyTaskTimePeriodEnum.Completed
                      ? "fa fa-check user-task-card-complete-icon"
                      : "fa fa-check user-task-card-incomplete-icon"
                  }
                ></div>
              )}
            </div>
          </div>
        </div>
        <div
          className={"user-task-card-description"}
          title={userTaskDescription}
        >
          {userTaskDescription}
        </div>
        <div className={"user-task-card-category-container"}>
          <div
            className={"user-task-card-category-name"}
            title={props.taskCategoryName}
          >
            {props.taskCategoryName}
          </div>
          <div
            className={"user-task-card-category-type"}
            title={props.taskCategoryTypeDisplayName}
          >
            {props.taskCategoryTypeDisplayName}
          </div>
        </div>
      </div>
    </div>
  );
};
export default TaskCard;
